<template>
  <div class="u-wrap">
    <van-form>
      <van-cell :title="model.ajdd" @click="showMap=true">
        <van-icon name="location" color="#1777FF" slot="icon" style="margin-top: 5px; margin-right: 5px" />
      </van-cell>
      <select-person
        :required="true"
        readonly
        clickable
        v-model="sqrList"
        label="申请人"
        input-align="right"
        placeholder="请选择"
        title="申请人"
        sjryFl="01"
        right-icon="arrow-down"
      ></select-person>
      <select-person
        readonly
        clickable
        v-model="bsqrList"
        label="被申请人"
        input-align="right"
        placeholder="请选择"
        title="被申请人"
        sjryFl="02"
        right-icon="arrow-down"
      ></select-person>
      <u-picker
        style="margin-top: 12px"
        dictCode="mdjf_ajlx"
        :required="true"
        readonly
        clickable
        v-model="model.ajlx"
        label="案件类型"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow-down"
      ></u-picker>
      <van-field :required="true" v-model="model.anbt" label="案件标题" placeholder="20字以内" input-align="right" />
      <van-field
        :required="true"
        readonly
        clickable
        :value="model.slsj"
        label="矛盾纠纷受理时间"
        label-width="200"
        input-align="right"
        placeholder="请选择"
        @click="showTime = true"
        right-icon="arrow-down"
      />
      <div class="d-text">
        <div class="title">纠纷情况</div>
        <textarea placeholder="请输入纠纷情况" class="xxnr" v-model="model.jfxq"></textarea>
      </div>
      <div class="d-text">
        <div class="title">申请事项</div>
        <textarea placeholder="请描述您想通过调解达到怎样的目的" class="xxnr" v-model="model.sqsx"></textarea>
      </div>
      <div class="d-text">
        <div class="title">纠纷相关材料</div>
        <van-uploader
          style="margin-left: 12px"
          v-model="fileList"
          :max-count="6"
          :after-read="afterRead"
          :before-delete="beforeDelete"
        />
      </div>

      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker type="date" title="选择年月日" v-model="currentDate" @confirm="confirmTime" />
      </van-popup>
    </van-form>
    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="clickSumbit">提交</button>
    </div>
      <van-popup v-model="showMap" position="bottom" :style="{ height: '100%' }"  :lock-scroll="false">
         <iframe id="mapPage" width="100%" height="100%" frameborder=0
          :src="iframeUrl" 
         >
        </iframe>
      </van-popup>
   
  </div>
</template>

<script>
import { getAction, putAction, uploadAction, postAction } from '@/api/manage'
import uPicker from '@/components/page/u-picker.vue'
import { isMobile, isCardID } from '@/utils/validate'
import wx from 'weixin-js-sdk'
import USelect from '../../components/page/u-select.vue'
import SelectPerson from '../common/select-person.vue'
export default {
  components: {
    uPicker,
    USelect,
    SelectPerson,
  },
  data() {
    return {
      url: '/system/sysuserwechatbind/edit',
      model: {
        ajlx: '',
        anbt: '',
        ajdd: '',
        jd: '',
        wd: '',
        sqsx: '',
        jfxq: '',
        slsj: '',
        tp: '',
        flowAction: 'gzhsb',
        ajly: '02',
        openId: '',
      },
      ajlxName: '',
      show: false,
      showTime: false,
      columns: [],
      fileList: [],
      currentDate: new Date(),
      sqrList: [],
      bsqrList: [],
      showMap:false,
      iframeUrl:'https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=MNHBZ-FHJ6J-K23FZ-F6M7D-IIZDT-BFBFO&referer=myapp',
    }
  },
  created() {
    this.initData()
    this.initWxInfo()
    this.getAddress()
  },
  computed: {
    disable() {
      let disable = true
      if (this.model.ajlx && this.model.anbt && this.model.slsj && this.sqrList.length > 0) {
        disable = false
      }

      return disable
    },
  },
  methods: {
    confirmTime(value) {
      let date = value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate()
      this.model.slsj = date
      this.showTime = false
    },
    uploadFile(file, index) {
      let url = '/sys/common/upload'
      let formData = new FormData()
      formData.append('file', file)
      uploadAction(url, formData)
        .then((res) => {
          if (res.success) {
            let url = res.message
            let obj = { url: url }
            this.fileList[index] = obj
          } else {
            this.fileList.splice(index, 1)
          }
        })
        .catch((err) => {
          this.$toast('上传文件超时')
          this.fileList.splice(index, 1)
        })
    },
    afterRead(file, detail) {
      // 此时可以自行将文件上传至服务器
      console.log(file)
      this.uploadFile(file.file, detail.index)
    },
    beforeDelete(file, detail) {
      let index = detail.index
      this.fileList.splice(index, 1)
    },
    initData() {
      let params = { category: '2' }
      getAction('/sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
        if (res.success) {
          let list = res.result
          this.columns = list
        }
      })
    },
    clickSumbit() {
      this.model.openId = this.$store.getters.openId
      this.model.mdjfSjglSjryxxDtoList = [...this.sqrList, ...this.bsqrList]
      let arr = this.fileList.map((obj) => {
        return obj.url
      })
      this.model.tp = arr.join(',')
      postAction('/zhshj/mdjfsjgl/gzhsb', this.model).then((res) => {
        if (res.success) {
          this.$router.replace({
            name: 'success',
          })
        }
      })
    },
    //调用接口
    initWxInfo() {
      let urlHref = encodeURIComponent(window.location.href)
      let params = { url: urlHref }
      let url = `/sys/mlogin/get/jsdk?url=${urlHref}`
      postAction(url, params).then((res) => {
        if (res.success) {
          let obj = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: obj.appId, // 必填，公众号的唯一标识
            timestamp: obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: obj.nonceStr, // 必填，生成签名的随机串
            signature: obj.signature, // 必填，签名，见附录1
            jsApiList: ['getLocation'],
          })
        }
      })
    },
    getAddress() {
      let _this = this
      wx.ready(() => {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
        wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (d) => {
            var latitude = d.latitude // 纬度，浮点数，范围为90 ~ -90
            var longitude = d.longitude // 经度，浮点数，范围为180 ~ -180。
            _this.model.jd = longitude
            _this.model.wd = latitude
            _this.iframeUrl = `https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=MNHBZ-FHJ6J-K23FZ-F6M7D-IIZDT-BFBFO&referer=myapp&coord=${latitude},${longitude}`;
            var latLng = new qq.maps.LatLng(d.latitude, d.longitude)
            getAddr.getAddress(latLng)
          },
          fail: (d) => {
            this.$toast('获取微信坐标位置失败，请点击右上角‘…’→刷新一下，谢谢配合！')
          },
        })
      })
      wx.error((err) => {
        console.log(error)
      })

      var getAddr = new qq.maps.Geocoder({
        complete: function (res) {
          // _this.address = res.detail
          // var allAddress = res.detail.addressComponents
          var address = res.detail.address
          _this.model.ajdd = address
        },
      })
    },
    onConfirm(value, index) {
      this.model.sysOrgCode_dictText = value.join('-')
      let index1 = index[0]
      let index2 = index[1]
      let index3 = index[2]
      try {
        let sysOrgCode = this.columns[index1].children[index2].children[index3].orgCode
        this.model.sysOrgCode = sysOrgCode
      } catch (error) {}

      this.show = false
    },
  },
  mounted(){
    window.addEventListener('message', (event)=>{
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          let latLng = loc.latlng
          this.model.ajdd = loc.poiaddress;
          this.model.jd = latLng.lng;
          this.model.wd = latLng.lat;
          this.showMap = false;

        }
    }, false);
  }
}
</script>

<style lang="less" scoped>
.u-wrap {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
  height: calc(100% - 60px);
  padding-bottom: 60px;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 60px;
}

.xxnr {
  margin: 0 12px;
  height: 120px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
  width: 86%;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
  height: 60px;
  background: #ffffff;
  display: flex;
  align-items: center;

  .b-button {
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
    margin: 0 5%;
    width: 90%;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.d-text {
  width: 100%;
  background: #ffffff;
  margin-top: 12px;

  .title {
    padding-left: 12px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
  }
}
</style>
